import React from "react";
import ArtistList from "./../ArtistList";

const Artists = () => {
    return (
        <div>
            <div className="ui container">
                <h3>Artists</h3>
            </div>
            <ArtistList/>
        </div>
    );
};

export default Artists;